import React, { useState, useEffect } from 'react';

const Navigation = ({ currentSection, setCurrentSection }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const sections = ['home', 'albums', 'films', 'story', 'news', 'merch', 'contact'];
  const isHome = currentSection === 'home';
  
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  
  const handleSectionChange = (section) => {
    setCurrentSection(section);
    setMenuOpen(false);
  };
  
  if (isHome) {
    return (
      <nav style={isMobile ? {...styles.navHome, ...styles.navHomeMobile} : styles.navHome}>
        <div style={styles.containerHome}>
          <div style={isMobile ? {...styles.menuHome, ...styles.menuHomeMobile} : styles.menuHome}>
            {sections.filter(s => s !== 'home').map(section => (
              <button
                key={section}
                onClick={() => handleSectionChange(section)}
                style={isMobile ? {...styles.buttonHome, ...styles.buttonHomeMobile} : styles.buttonHome}
              >
                {section.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </nav>
    );
  }
  
  return (
    <nav style={styles.nav}>
      <div style={styles.container}>
        <div 
          style={isMobile ? {...styles.logo, ...styles.logoMobile} : styles.logo}
          onClick={() => handleSectionChange('home')}
        >
          PANTERA MG
        </div>
        
        {isMobile && (
          <button 
            style={styles.hamburger}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span style={{...styles.hamburgerLine, ...(menuOpen && styles.hamburgerLineOpen1)}}></span>
            <span style={{...styles.hamburgerLine, ...(menuOpen && styles.hamburgerLineOpen2)}}></span>
            <span style={{...styles.hamburgerLine, ...(menuOpen && styles.hamburgerLineOpen3)}}></span>
          </button>
        )}
        
        {!isMobile && (
          <div style={styles.menuDesktop}>
            {sections.map(section => (
              <button
                key={section}
                onClick={() => handleSectionChange(section)}
                style={{
                  ...styles.button,
                  ...(currentSection === section ? styles.buttonActive : {})
                }}
              >
                {section.toUpperCase()}
              </button>
            ))}
          </div>
        )}
        
        {isMobile && menuOpen && (
          <div style={styles.menuMobile}>
            {sections.map(section => (
              <button
                key={section}
                onClick={() => handleSectionChange(section)}
                style={{
                  ...styles.buttonMobile,
                  ...(currentSection === section ? styles.buttonMobileActive : {})
                }}
              >
                {section.toUpperCase()}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

const styles = {
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    background: 'rgba(0,0,0,0.95)',
    borderBottom: '1px solid #333',
    zIndex: 1000,
    padding: '1rem 2rem',
    fontFamily: 'Roboto, sans-serif',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  logo: {
    fontSize: '1.5rem',
    fontWeight: 400,
    letterSpacing: '2px',
    color: '#fff',
    cursor: 'pointer',
    fontFamily: 'Roboto, sans-serif',
  },
  logoMobile: {
    fontSize: '1.2rem',
    fontWeight: 400,
  },
  hamburger: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    width: '30px',
    height: '25px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    zIndex: 1001,
  },
  hamburgerLine: {
    width: '100%',
    height: '3px',
    background: '#fff',
    transition: 'all 0.3s',
    transformOrigin: 'center',
  },
  hamburgerLineOpen1: {
    transform: 'rotate(45deg) translateY(8px)',
  },
  hamburgerLineOpen2: {
    opacity: 0,
  },
  hamburgerLineOpen3: {
    transform: 'rotate(-45deg) translateY(-8px)',
  },
  menuDesktop: {
    display: 'flex',
    gap: '2rem',
  },
  button: {
    background: 'none',
    border: 'none',
    color: '#999',
    cursor: 'pointer',
    fontSize: '0.9rem',
    letterSpacing: '1px',
    transition: 'color 0.3s',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
  },
  buttonActive: {
    color: '#fff',
  },
  menuMobile: {
    position: 'fixed',
    top: '64px',
    left: 0,
    right: 0,
    background: 'rgba(0,0,0,0.98)',
    display: 'flex',
    flexDirection: 'column',
    padding: '2rem',
    gap: '1.5rem',
    borderBottom: '1px solid #333',
  },
  buttonMobile: {
    background: 'none',
    border: 'none',
    color: '#999',
    cursor: 'pointer',
    fontSize: '1.1rem',
    letterSpacing: '2px',
    transition: 'color 0.3s',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
    textAlign: 'left',
    padding: '0.5rem 0',
  },
  buttonMobileActive: {
    color: '#fff',
  },
  navHome: {
    position: 'fixed',
    top: '17%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1000,
    background: 'transparent',
    fontFamily: 'Roboto, sans-serif',
    width: '90%',
    maxWidth: '600px',
  },
  navHomeMobile: {
    top: '20%',
    width: '95%',
  },
  containerHome: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '3rem',
  },
  menuHome: {
    display: 'flex',
    gap: '1.5rem',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    padding: '0 1rem',
  },
  menuHomeMobile: {
    gap: '1rem',
    flexWrap: 'wrap',
  },
  buttonHome: {
    background: 'none',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
    fontSize: '1rem',
    letterSpacing: '2px',
    transition: 'all 0.3s',
    textShadow: '0 0 10px rgba(255, 255, 255, 0.5)',
    padding: '0.5rem 1rem',
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 500,
  },
  buttonHomeMobile: {
    fontSize: '0.85rem',
    letterSpacing: '1.5px',
    padding: '0.4rem 0.8rem',
  },
};

export default Navigation;